import { render } from "./df-number-resize.vue?vue&type=template&id=152f4dba&scoped=true"
import script from "./df-number-resize.vue?vue&type=script&lang=js"
export * from "./df-number-resize.vue?vue&type=script&lang=js"

import "./df-number-resize.vue?vue&type=style&index=0&id=152f4dba&scoped=true&lang=css"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152f4dba"]])

export default __exports__